"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rerender = void 0;
var Rerender_1 = require("./Rerender");
Object.defineProperty(exports, "Rerender", { enumerable: true, get: function () { return __importDefault(Rerender_1).default; } });
